import { BUSINESS_LOGO_OUTPUT_PX } from '../constants/businessLogoDisplay';

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (err) => reject(err));
    image.setAttribute('crossOrigin', 'anonymous');
    image.src = src;
  });
}

/**
 * Renders the cropped region into a square PNG blob.
 * @param {string} imageSrc — blob: URL or same-origin URL
 * @param {{ x: number, y: number, width: number, height: number }} pixelCrop — from react-easy-crop onCropComplete
 * @param {number} [outputSize]
 * @returns {Promise<Blob>}
 */
export async function getCroppedLogoBlob(imageSrc, pixelCrop, outputSize = BUSINESS_LOGO_OUTPUT_PX) {
  const image = await loadImage(imageSrc);
  const canvas = document.createElement('canvas');
  canvas.width = outputSize;
  canvas.height = outputSize;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('Canvas not supported');
  }

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    outputSize,
    outputSize,
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) reject(new Error('Failed to encode image'));
        else resolve(blob);
      },
      'image/png',
      1,
    );
  });
}
